import chatFlow from "@/http/requests/chatFlow"

export default {
  fetch({ commit }, searchParams = {}) {
    return new Promise((resolve, reject) => {
      chatFlow.fetch(searchParams).then(response => {
        commit('SET_CHAT_FLOWS', response.data.data.chatOptions)
        resolve(response)
      })
      .catch((error) => { reject(error) })
    })
  },
  infos({ commit }, chatFlowId) {
    return new Promise((resolve, reject) => {
      chatFlow.infos(chatFlowId).then(response => {
        commit('SET_CHAT_FLOW_INFOS', response.data.data.chatOptionInfos)
        resolve(response)
      })
      .catch((error) => { reject(error) })
    })
  },
  backInfos(_, parent_id) {
    return new Promise(
      ( resolve, reject ) => {
        chatFlow.backInfos( parent_id )
          .then( response => resolve(response) )
          .catch( error => reject(error) );
      }
    );
  },
  add(_, data) {
    return new Promise((resolve, reject) => {
      chatFlow.add(data).then(response => {
        resolve(response)
      })
      .catch((error) => { reject(error) })
    })
  },
  update(_, data) {
    return new Promise((resolve, reject) => {
      chatFlow.update(data).then(response => {
        resolve(response)
      })
      .catch((error) => { reject(error) })
    })
  },
  delete(_, chatFlowId) {
    return new Promise((resolve, reject) => {
      chatFlow.delete(chatFlowId).then(response => {
        resolve(response)
      })
      .catch((error) => { reject(error) })
    })
  }
}
